/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sales_Status_Nodata1Inputs */

const id_sales_status_nodata1 = /** @type {(inputs: Sales_Status_Nodata1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada data`)
};

const ms_sales_status_nodata1 = /** @type {(inputs: Sales_Status_Nodata1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada data`)
};

const da_sales_status_nodata1 = /** @type {(inputs: Sales_Status_Nodata1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen data`)
};

const de_sales_status_nodata1 = /** @type {(inputs: Sales_Status_Nodata1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Daten`)
};

const en_us2_sales_status_nodata1 = /** @type {(inputs: Sales_Status_Nodata1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No data`)
};

const es_es2_sales_status_nodata1 = /** @type {(inputs: Sales_Status_Nodata1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin datos`)
};

const es_mx2_sales_status_nodata1 = /** @type {(inputs: Sales_Status_Nodata1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin datos`)
};

const fil_sales_status_nodata1 = /** @type {(inputs: Sales_Status_Nodata1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang data`)
};

const fr_sales_status_nodata1 = /** @type {(inputs: Sales_Status_Nodata1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune donnée`)
};

const it_sales_status_nodata1 = /** @type {(inputs: Sales_Status_Nodata1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun dato`)
};

const hu_sales_status_nodata1 = /** @type {(inputs: Sales_Status_Nodata1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nincs adat`)
};

const nl_sales_status_nodata1 = /** @type {(inputs: Sales_Status_Nodata1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen gegevens`)
};

const no_sales_status_nodata1 = /** @type {(inputs: Sales_Status_Nodata1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen data`)
};

const pl_sales_status_nodata1 = /** @type {(inputs: Sales_Status_Nodata1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak danych`)
};

const pt_br2_sales_status_nodata1 = /** @type {(inputs: Sales_Status_Nodata1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem dados`)
};

const pt_sales_status_nodata1 = /** @type {(inputs: Sales_Status_Nodata1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem dados`)
};

const ro_sales_status_nodata1 = /** @type {(inputs: Sales_Status_Nodata1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fără date`)
};

const fi_sales_status_nodata1 = /** @type {(inputs: Sales_Status_Nodata1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei tietoja`)
};

const sv_sales_status_nodata1 = /** @type {(inputs: Sales_Status_Nodata1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen data`)
};

const vi_sales_status_nodata1 = /** @type {(inputs: Sales_Status_Nodata1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có dữ liệu`)
};

const tr_sales_status_nodata1 = /** @type {(inputs: Sales_Status_Nodata1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veri yok`)
};

const cs_sales_status_nodata1 = /** @type {(inputs: Sales_Status_Nodata1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádná data`)
};

const bg_sales_status_nodata1 = /** @type {(inputs: Sales_Status_Nodata1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Няма данни`)
};

const ru_sales_status_nodata1 = /** @type {(inputs: Sales_Status_Nodata1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет данных`)
};

const uk_sales_status_nodata1 = /** @type {(inputs: Sales_Status_Nodata1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Немає даних`)
};

const ar_sales_status_nodata1 = /** @type {(inputs: Sales_Status_Nodata1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد بيانات`)
};

const hi_sales_status_nodata1 = /** @type {(inputs: Sales_Status_Nodata1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई डेटा नहीं`)
};

const th_sales_status_nodata1 = /** @type {(inputs: Sales_Status_Nodata1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่มีข้อมูล`)
};

const ja_sales_status_nodata1 = /** @type {(inputs: Sales_Status_Nodata1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`データがありません`)
};

const zh_cn2_sales_status_nodata1 = /** @type {(inputs: Sales_Status_Nodata1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无数据`)
};

const zh_hant1_sales_status_nodata1 = /** @type {(inputs: Sales_Status_Nodata1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無資料`)
};

const ko_sales_status_nodata1 = /** @type {(inputs: Sales_Status_Nodata1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`데이터 없음`)
};

/**
* | output |
* | --- |
* | "No data" |
*
* @param {Sales_Status_Nodata1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sales_status_nodata1 = /** @type {((inputs?: Sales_Status_Nodata1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sales_Status_Nodata1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sales_status_nodata1(inputs)
	if (locale === "ms") return ms_sales_status_nodata1(inputs)
	if (locale === "da") return da_sales_status_nodata1(inputs)
	if (locale === "de") return de_sales_status_nodata1(inputs)
	if (locale === "en-US") return en_us2_sales_status_nodata1(inputs)
	if (locale === "es-ES") return es_es2_sales_status_nodata1(inputs)
	if (locale === "es-MX") return es_mx2_sales_status_nodata1(inputs)
	if (locale === "fil") return fil_sales_status_nodata1(inputs)
	if (locale === "fr") return fr_sales_status_nodata1(inputs)
	if (locale === "it") return it_sales_status_nodata1(inputs)
	if (locale === "hu") return hu_sales_status_nodata1(inputs)
	if (locale === "nl") return nl_sales_status_nodata1(inputs)
	if (locale === "no") return no_sales_status_nodata1(inputs)
	if (locale === "pl") return pl_sales_status_nodata1(inputs)
	if (locale === "pt-BR") return pt_br2_sales_status_nodata1(inputs)
	if (locale === "pt") return pt_sales_status_nodata1(inputs)
	if (locale === "ro") return ro_sales_status_nodata1(inputs)
	if (locale === "fi") return fi_sales_status_nodata1(inputs)
	if (locale === "sv") return sv_sales_status_nodata1(inputs)
	if (locale === "vi") return vi_sales_status_nodata1(inputs)
	if (locale === "tr") return tr_sales_status_nodata1(inputs)
	if (locale === "cs") return cs_sales_status_nodata1(inputs)
	if (locale === "bg") return bg_sales_status_nodata1(inputs)
	if (locale === "ru") return ru_sales_status_nodata1(inputs)
	if (locale === "uk") return uk_sales_status_nodata1(inputs)
	if (locale === "ar") return ar_sales_status_nodata1(inputs)
	if (locale === "hi") return hi_sales_status_nodata1(inputs)
	if (locale === "th") return th_sales_status_nodata1(inputs)
	if (locale === "ja") return ja_sales_status_nodata1(inputs)
	if (locale === "zh-CN") return zh_cn2_sales_status_nodata1(inputs)
	if (locale === "zh-Hant") return zh_hant1_sales_status_nodata1(inputs)
	return ko_sales_status_nodata1(inputs)
});
export { sales_status_nodata1 as "sales.status.noData" }